import React from 'react';
import { AppText } from '@frontend-modules/ui-kit';
import { E_COLORS } from 'src-new/constants';

import { INotificationTimeIndicatorProps } from './NotificationTimeIndicator.types';

import './NotificationTimeIndicator.style.scss';
export const NotificationTimeIndicator: React.FC<INotificationTimeIndicatorProps> = (props) => {
    const { isCollapsed, isMeetingStarted, isMeetingFinished, time } = props;
    const timerLabel = isMeetingFinished ? 'Закончился' : isMeetingStarted ? 'Идёт' : 'Через';
    return (
        <div className={`notification-time-indicator ${isCollapsed && 'collapsed'}  ${isMeetingStarted && 'warning'}`}>
            <AppText
                className={`time-indicator-label ${isCollapsed && 'hidden'}`}
                text={timerLabel}
                textStyle={'DesktopFootNotes'}
                color={E_COLORS.light_grey_color_2}
            />
            <AppText
                className={`time-indicator-timer ${isCollapsed && 'collapsed'}`}
                text={time}
                color={
                    isCollapsed
                        ? E_COLORS.white_color
                        : isMeetingStarted
                        ? E_COLORS.coral_color
                        : E_COLORS.firm_blue_color
                }
                textStyle={isCollapsed ? 'DesktopH4' : 'DesktopH1'}
            />
        </div>
    );
};
